"use strict";

angular.module("customer")
.controller("paymentController", function(
    $scope, $stateParams, $q, $filter, UserService, StateExtensionService, Language, FlashBag, gettextCatalog,
    PaymentService, PatternService, ZebraPrinterService, FormError,
    PAYMENT_USER_VERIFICATION_TYPES, PAYMENT_USER_VERIFICATION_REQUIRED, PAYMENT_METHODS
) {
    $scope.pattern = PatternService;
    $scope.vendors = [];
    $scope.params = angular.extend({}, $stateParams);

    Language.initializeScope($scope, "language", "locale");
    var _this = this;

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
            $scope.isUserCanPay = user.is_user_can_pay;
        }
    });

    this.selectSingle = function(vendor, invoice) {
        if (!invoice.selected) {
            vendor.selectAll = false;
        }
        this.updateTotalAmount();
    };

    this.search = function() {
        var selectedInvoices = "";
        if ($scope.params.selected !== undefined) {
            selectedInvoices = $scope.params.selected.split(',');
        }

        PaymentService.queryUnpaidInvoices($scope.params).$promise
        .then(function onSuccess(data) {
            $scope.vendors = data;
            $scope.vendors.forEach(function(vendor) {
                vendor.selectAll = !!$scope.params.selectAll;
                vendor.invoices.forEach(function(invoice) {
                    invoice.selected = vendor.selectAll || selectedInvoices.includes(invoice.id.toString());
                    if (invoice.selected) {
                        invoice.amount = invoice.current_unpaid_amount;
                    }
                });
            });
            _this.updateTotalAmount();
        });
    };

    this.updateCheckboxState = function(invoice) {
        if (invoice) {
            invoice.selected = !isNaN(parseFloat(invoice.amount));
            this.updateTotalAmount();
        }
    };

    this.updateTotalAmount = function() {
        $scope.vendors.forEach(function(vendor) {
            vendor.selectedCount = 0;
            vendor.totalCount = 0;
            vendor.paymentTotalAmount = 0;
            vendor.invoices.forEach(function(invoice) {
                vendor.totalCount += 1;
                if (invoice.selected) {
                    vendor.selectedCount += 1;
                    if (isNaN(parseFloat(invoice.amount))) {
                        invoice.amount = invoice.current_unpaid_amount;
                    }
                    vendor.paymentTotalAmount += parseFloat(invoice.amount);
                }
                else if (invoice.amount !== undefined) { // Condition to catch minus symbol(- === undefined)
                    invoice.amount = null;
                }
            });
            vendor.selectAll = vendor.selectedCount === vendor.totalCount;
        });
    }

    this.isDisabledPayButton = function(vendor) {
        return (
            !$scope.isUserCanPay
            || vendor.disabledPayButton
            || vendor.selectedCount === 0
            || !vendor.method
            || (vendor.method === PAYMENT_METHODS.BANK_TRANSFER && !vendor.selected_bank_account_id)
            || (vendor.method === PAYMENT_METHODS.CREDIT_CARD && !vendor.selected_credit_card_account_id)
        );
    };

    this.pay = function(form, vendor) {
        if (this.isDisabledPayButton(vendor)) {
            return;
        }

        form.$setSubmitted();
        FormError.focus(form.$name);
        if (!form.$valid) {
            return;
        }

        vendor.disabledPayButton = true;

        var invoice_payments = [];
        vendor.invoices.forEach(function(invoice) {
            if (invoice.selected) {
                invoice_payments.push({
                    invoice: invoice.id,
                    amount: invoice.amount
                });
            }
        });

        var data = {
            vendor: vendor.id,
            method: vendor.method,
            selected_bank_account_id: vendor.selected_bank_account_id,
            selected_credit_card_account_id: vendor.selected_credit_card_account_id,
            check_number: vendor.check_number,
            invoice_payments: invoice_payments
        };

        FlashBag.clearAll();
        return PaymentService.create(data).then(function onSuccess(payment) {
            FlashBag.success(
                gettextCatalog.getString(
                    "Payment creation successful. Transaction number: {{transactionNumber}}",
                    {transactionNumber: payment.transaction_number}
                ),
                true
            );
            _this.search();
            return payment;
        }, function onError(response) {
            FlashBag.clearAll();
            if (Array.isArray(response.data.invoice_payments)) {
                response.data.invoice_payments.forEach(function(error) {
                    var invoice_number = Object.keys(error)[0];
                    if (form[invoice_number] !== undefined) {
                        form[invoice_number].hasError = true;
                        form[invoice_number].errorMessage = error[invoice_number][0];
                        form[invoice_number].$setPristine();
                    }
                });
            }
            FlashBag.apiError(response);
            vendor.disabledPayButton = false;
            return $q.reject(response);
        });
    };

    this.payAndPrint = function(form, vendor) {
        this.pay(form, vendor).then(
            function onSuccess(payment) {
                if (ZebraPrinterService.isSupported()) {
                    PaymentService.printReceiptPDF(
                        payment.id
                    );
                } else {
                    PaymentService.downloadReceiptPDF(
                        payment.id
                    );
                }
            }
        )
    };

    this.getUserVerificationType = function(vendor) {
        return PAYMENT_USER_VERIFICATION_TYPES[vendor.method];
    };

    this.isUserVerificationRequired = function(vendor) {
        return PAYMENT_USER_VERIFICATION_REQUIRED.includes(vendor.method);
    };

    this.search();
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/payment/payment.controller.js
// module id = 919
// module chunks = 0